import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ApplicantPreferenceData {
  // Basic preference data
  floorplanIds: string[]; // Original floorplan IDs for API calls

  // Additional context data
  leaseTermId?: string; // Selected lease term ID
  lastUpdated?: string; // Timestamp of last update
}

export interface WaitlistPreferencesState {
  applicantPreferences: Record<string, ApplicantPreferenceData>; // applicantId -> preference data
}

const initialState: WaitlistPreferencesState = {
  applicantPreferences: {},
};

const waitlistPreferencesSlice = createSlice({
  name: 'waitlistPreferences',
  initialState,
  reducers: {
    // Update preferences with full context data
    updateApplicantPreferences: (
      state,
      action: PayloadAction<{
        applicantId: string;
        floorplanIds: string[];
        leaseTermId?: string;
      }>
    ) => {
      const { applicantId, floorplanIds, leaseTermId } = action.payload;

      return {
        ...state,
        applicantPreferences: {
          ...state.applicantPreferences,
          [applicantId]: {
            floorplanIds,
            leaseTermId,
            lastUpdated: new Date().toISOString(),
          },
        },
      };
    },
  },
});

export const {
  updateApplicantPreferences
} = waitlistPreferencesSlice.actions;

export default waitlistPreferencesSlice.reducer;
